/**
 * Copyright © 2026 Adnuntius AS.
 */
import _ from 'lodash';

const immediateFields = [
  'axProduct',
  'userState',
  'type',
  'targeting',
  'rateLimits',
  'submissionMessage'
];

const deliveryLabelFields = [
  'executionState',
  'executionStateEndedReason',
  'validationWarnings',
  'objectiveDeliveryPredictions'
];

const bidSpecificationFields = [
  'cpmFees',
  'cpmTechFee',
  'supplementaryFees',
  'audienceFees',
  'cpm',
  'cpc'
];

export function applyPersistedLineItemImmediateState(
  editingModel: any,
  persistedModel: any,
  persistedLineItem: any
): void {
  Object.assign(editingModel, _.pick(persistedLineItem, immediateFields));
  Object.assign(persistedModel, _.pick(persistedLineItem, immediateFields));

  bidSpecificationFields.forEach((field) => {
    const value = _.get(persistedLineItem, ['bidSpecification', field]);
    _.set(editingModel, ['bidSpecification', field], value);
    _.set(persistedModel, ['bidSpecification', field], value);
  });

  editingModel.order = persistedLineItem.order;
  persistedModel.order = persistedLineItem.order;
}

export function applyPersistedLineItemDeliveryState(
  editingModel: any,
  persistedModel: any,
  persistedLineItem: any
): void {
  editingModel.executionStateEndedReason = null;
  Object.assign(editingModel, _.pick(persistedLineItem, deliveryLabelFields));
  Object.assign(persistedModel, _.pick(persistedLineItem, deliveryLabelFields));
}
